import { fonts } from '../global/Fonts';

export default {
  heading: `${fonts.soehneBreit}, -apple-system, system-ui, sans-serif`,
  body: `${fonts.soehne}, -apple-system, system-ui, sans-serif`,
};
